import { SummaryMetadata, SummaryMetadataBody } from 'api/types';

export const checkSummaryDataInMetadata = (metadata: object | null) => {
    return metadata !== null && 'audioEgress' in metadata;
};

export const parseSummaryDataFromMetadata = (
    metadata: Partial<SummaryMetadata> | { audioEgress?: SummaryMetadataBody } | null,
) => {
    return metadata?.audioEgress || null;
};
